export const VIDEO_PLAYER_COLORS = {
  /* we want to use the white color both in light and dark mode */
  WHITE: '#ffffff',
  WHITE_12: 'rgb(255 255 255 / 12%)',
  BLACK: '#000000',
  BLACK_66: 'rgb(0 0 0 / 66%)',
  PROGRESS_BAR_RAIL: '#f2f5fa',
  LOADING_BAR: '#c1cad9',
  AUTO_NEXT_OVERLAY_NEXT_ITEM_DURATION: '#c1cad9',
} as const;
